import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectEngagementPercent } from '@store/submissions'
import Theme from '@theme'
import { H5 } from '@tribegroup'

interface IProps {
  submissionId: number
}

const SubHeaderLabelEngagementPercent: React.FC<IProps> = ({ submissionId }) => {
  const engagementPercent = useSelector((state: IApplicationState) =>
    selectEngagementPercent(state, submissionId),
  )

  return (
    <H5 color={Theme.grey700Color} uppercase inline light>
      {Boolean(engagementPercent) && (
        <FormattedMessage
          id="submission.performance.averageEngagementPercentWithValue"
          values={{ value: engagementPercent }}
        />
      )}
    </H5>
  )
}

export { SubHeaderLabelEngagementPercent }
export default SubHeaderLabelEngagementPercent
